<div class="view-filters-active">
  <div class="total">Filters: {{ selectedOptions.length }}</div>

  @if (selectedOptions.length > 0) {
    <div class="separator">|</div>
    <div class="clear" (click)="clearSelectedFilters()">Clear all</div>
  }

  @if (selectedOptions.length > 0) {
    <div class="selected-filter-container">
      @for (chipDisplay of filterChipsToDisplay; track $index) {
        @if (chipDisplay.type === 'individual') {
          <div class="selected-filter">
            <div class="text">
              {{ chipDisplay.option!.categoryName ? chipDisplay.option!.categoryName + ': ' : ''
              }}{{
                chipDisplay.option!.withoutBeautifyDisplayName
                  ? chipDisplay.option!.displayName
                  : (chipDisplay.option!.displayName | beautifyDisplayString)
              }}
            </div>
            <img
              src="assets/images/common/cancel-hollow.svg"
              (click)="clearSingleOption(chipDisplay.option!)"
              alt="cancel"
            />
          </div>
        }
        @if (chipDisplay.type === 'aggregated') {
          <div class="selected-filter selected-filter-aggregated">
            <div class="text">{{ chipDisplay.categoryName }}: {{ chipDisplay.count }} selected</div>
            <img
              src="assets/images/common/cancel-hollow.svg"
              (click)="clearAggregatedCategory(chipDisplay.categoryName!)"
              alt="cancel"
            />
          </div>
        }
      }
    </div>
  }
</div>
